import { render, staticRenderFns } from "./AutomaticUploadsHistoryForm.vue?vue&type=template&id=c80036ce&scoped=true&"
import script from "./AutomaticUploadsHistoryForm.vue?vue&type=script&lang=js&"
export * from "./AutomaticUploadsHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticUploadsHistoryForm.vue?vue&type=style&index=0&id=c80036ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80036ce",
  null
  
)

export default component.exports
import {QCardSection,QForm,QScrollArea,QInput,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QForm,QScrollArea,QInput,QBtn,QTooltip})
